import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import moment from 'moment';

import UserAvatar from 'components/UserAvatar';
import './style.scss';
import DetailLabel from 'components/DetailLabel';
import { ChatMessageShape } from 'entities';

class ChatMessage extends Component {

  render() {
    const chatMessage = this.props.chatMessage;

    const className = classnames('ChatMessage', {
      'by-counsellor': chatMessage.fromCounsellor,
      'by-user': !chatMessage.fromCounsellor
    });

    return (
      <div className={className}>
        {(() => {
          if(this.props.avatarImageUrl) {
            return (
              <div className="avatar">
                <UserAvatar hasImage imageUrl={this.props.avatarImageUrl} />
              </div>
            );
          }
        })()}

        <div className="content">
          <div className="bubble">
            {this.props.children}
          </div>

          <div className="meta">
            <DetailLabel>{moment(chatMessage.createdAt).fromNow()}</DetailLabel>
          </div>
        </div>
      </div>
    );
  }
}

ChatMessage.propTypes = {
  chatMessage: ChatMessageShape,
  avatarImageUrl: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default ChatMessage;



/** WEBPACK FOOTER **
 ** ./src/members/Main/ChatWindow/ChatItems/ChatMessage/index.js
 **/